import { render, staticRenderFns } from "./OutboundScreen.vue?vue&type=template&id=12353097&"
import script from "./OutboundScreen.vue?vue&type=script&lang=ts&"
export * from "./OutboundScreen.vue?vue&type=script&lang=ts&"
import style0 from "./OutboundScreen.vue?vue&type=style&index=0&id=12353097&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VDialog})
